import React from 'react';
import PropTypes from 'prop-types';

import './Comic.css';

class Comic extends React.Component {
  static propTypes = {
    comic: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      images: PropTypes.arrayOf(PropTypes.shape({
        createdAt: PropTypes.string,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        alt: PropTypes.string,
        url: PropTypes.string,
      })),
    }),
  };

  state = {
    currentImageIndex: 0
  };

  setImageIndex = (increment) => {
    const min = 0;
    const max = this.props.comic.images.length - 1;

    this.setState(state => {
      const currentImageIndex = Math.max(min, Math.min(max, state.currentImageIndex + increment));
      return { currentImageIndex };
    });
  };

  renderImage(image) {
    const { createdAt, title, alt, url } = image;
    return (
      <div key={url} className="Comic__image">
        <h3 className="Comic__title">{title}</h3>
        <div className="Comic__date">{createdAt}</div>
        <img className="Comic__image" src={url} alt={title} />
        <div className="Comic__alt">{alt}</div>
      </div>
    );
  }

  render() {
    const { name, images } = this.props.comic;

    if (images.length === 0) {
      return null;
    }

    // Note that these are "backwards" since the latest image is at index 0, and previous at 1, 2, etc.
    const hasPrevious = this.state.currentImageIndex < this.props.comic.images.length - 1;
    const hasNext = this.state.currentImageIndex > 0;
    const image = this.props.comic.images[this.state.currentImageIndex];

    return (
      <div className="Comic">
        <h2 className="Comic__name">{name}</h2>
        <button className="Comic__button" onClick={() => this.setImageIndex(1)} disabled={!hasPrevious}>&larr;</button>
        <button className="Comic__button" onClick={() => this.setImageIndex(-1)} disabled={!hasNext}>&rarr;</button>
        {this.renderImage(image)}
      </div>
    );
  }
}

export default Comic;



// WEBPACK FOOTER //
// ./src/Comic.js